import {
  createDocumentFlowOrgBeforeLoad,
  createDocumentFlowOrgLoader,
  createDocumentFlowOrgComponent,
} from '@/shared/utils/route-utils/document-flow-route-config'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_invoice-flow/org/$orgId')({
  beforeLoad: createDocumentFlowOrgBeforeLoad,
  loader: createDocumentFlowOrgLoader,
  component: createDocumentFlowOrgComponent('/_invoice-flow/org/$orgId'),
})
